{"lg":1200,"md":992,"sm":768,"xl":1440,"xs":576,"xxl":1920}